import React, { Component } from "react";
import GoogleLogin from "react-google-login";
import { Icon, Header } from "semantic-ui-react";
import "./Login.css";
import SearchSvg from "../../search.svg";
import logo from "../../logo.png";
import {
  Redirect
} from "react-router-dom";

class Login extends Component {
  state = {
    buttonText: "Login with Google to proceed"
  };

  render() {

    return (
      <section className="Login">
        <div className="ttoLogo">
          <img src={logo} alt="321 Web Marketing" />
        </div>
        <Header size="huge" as="h1" textAlign="center">
          Google Crawl Error Tool
        </Header>
        <div className="SearchImage">
          <img src={SearchSvg} alt="Search Image"/>
        </div>
        <GoogleLogin
          clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
          scope="https://www.googleapis.com/auth/webmasters"
          onSuccess={this.props.loadUser}
          onFailure={this.props.loginError}
          className="ui google plus huge button"
          // isSignedIn
        >
          <span className="ButtonText">{this.state.buttonText} </span>
          <Icon size='small' name="google" />
        </GoogleLogin>
      </section>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login/Login.js